import React, { FC, useCallback, useMemo } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { currencyFormatter, dateFormatter, DATE_FORMAT } from '../../utils/DataFormatterUtils';
import { Card } from 'antd';
import PaginatedReduxTable from '../paginated_redux_table/PaginatedReduxTable';
import { EmptyState } from '../empty_state/EmptyState';
import { equipmentCatalogChangesRestCrudThunksForSupplier } from '../../thunks/equipment_catalog_changes_thunks';
import DateTimeHover from '../date_time_component/DateTime';
import { userTimeZone } from '../../utils/DataConstants';

const EquipmentDetailPricesPage: FC<any> = ({ match }): React.ReactElement => {
	const equipmentTypeId = useMemo(() => match.params.id, [match.params.id]);

	const initialPagination = useMemo(
		() => ({
			current: 1,
			pageSize: 5,
		}),
		[]
	);

	const getContact = useCallback(
		(price) =>
			`${nullSafeGetOrElse('changedByContact.nameGiven', price, '')} ${nullSafeGetOrElse(
				'changedByContact.nameFamily',
				price,
				''
			)}`,
		[]
	);

	const columns = useMemo(
		() => [
			{
				title: 'Vendor',
				dataIndex: ['partEquipmentVendor', 'name'],
			},
			{
				title: 'Unit Cost',
				render: (_, record) => currencyFormatter()(nullSafeGetOrElse('unitCost', record, '')),
			},
			{
				title: 'Changed by',
				render: (_, record) => getContact(record),
			},
			{
				title: 'Changed at',
				dataIndex: 'createdAt',
				render: (createdAt) => (
					<DateTimeHover timestamp={createdAt} showDate timeZone={userTimeZone} />
				),
			},
		],
		[getContact]
	);

	return (
		<Card>
			<PaginatedReduxTable
				mode="list"
				updateQueryParams={true}
				emptyState={
					<EmptyState
						graphic={
							<img
								alt="No data"
								style={{ marginBottom: 8 }}
								src="https://s3.amazonaws.com/mock-data-assets/categories/images/box.svg"
							/>
						}
						headline={'No receipts found'}
					/>
				}
				collectionName="equipment_catalog_changes"
				targetCollectionName="equipmentCataloghangeIndex"
				columns={columns}
				showHeader={true}
				keyAccessor={(el) => el.id}
				initialPagination={initialPagination}
				additionalParams={{
					equipmentTypeId,
				}}
				fetchData={equipmentCatalogChangesRestCrudThunksForSupplier.read}
			/>
		</Card>
	);
};

export default withRouter<any, any>(connect()(EquipmentDetailPricesPage));
